import { apiRequest } from "../util/apiUtils";

export const taskList = async (params) => {
  try {
    const res = await apiRequest("get", `task/list`, {
      queries: { ...params, type: "Task" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taskAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `task/${payload?.id ? "edit" : "add"}`,
      {
        body: { ...payload, type: "Task" },
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
// export const taskAddEdit = async (payload) => {
//   console.log(payload.media, "payload in taskAddEdit");
//   try {
//     const formData = new FormData();

//     // Append fields from payload (non-media fields)
//     for (const key in payload) {
//       if (key === "media" && Array.isArray(payload.media)) {
//         // Handle media files
//         payload.media.forEach((fileObj) => {
//           if (fileObj?.file instanceof File) {
//             formData.append("media[]", fileObj.file); // Append the actual file
//           }
//         });
//       } else if (Array.isArray(payload[key])) {
//         // Handle array fields like categoryIds[]
//         payload[key].forEach((val) => {
//           formData.append(`${key}[]`, val);
//         });
//       } else if (payload[key] !== undefined && payload[key] !== null) {
//         formData.append(key, payload[key]);
//       }
//     }

//     // Make the API request with FormData
//     const res = await apiRequest(
//       payload?.id ? "put" : "post",
//       `task/${payload?.id ? "edit" : "add"}`,
//       {
//         body: formData,
//         headers: {
//           "Content-Type": "multipart/form-data", // This ensures file upload is handled correctly
//         },
//       }
//     );

//     return res?.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const taskDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `task/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taskStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `task/status`, {
      body: { ...payload, type: "Task" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const taskDetails = async (taskId) => {
  try {
    // const res = await apiRequest("get", `post/detail`, {
    //   queries: params,
    // });
    const res = await apiRequest("get", `task/detail/${taskId}`, {
      queries: { type: "Task" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
